import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-4ed81cfd"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "device-details-configuration" }
const _hoisted_2 = { class: "columns is-multiline" }
const _hoisted_3 = { class: "column is-12-touch is-6-desktop is-3-widescreen" }
const _hoisted_4 = { class: "device-section" }
const _hoisted_5 = { class: "has-text-weight-semibold" }
const _hoisted_6 = { class: "has-text-weight-semibold" }
const _hoisted_7 = { class: "column is-12-touch is-6-desktop is-3-widescreen" }
const _hoisted_8 = { class: "device-section" }
const _hoisted_9 = { class: "has-text-weight-semibold" }
const _hoisted_10 = { class: "has-text-weight-semibold" }
const _hoisted_11 = { class: "has-text-weight-semibold" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_n_descriptions_item = _resolveComponent("n-descriptions-item")!
  const _component_n_descriptions = _resolveComponent("n-descriptions")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_n_descriptions, {
            hoverable: "",
            "label-placement": "left",
            title: _ctx.$t('device_details.overview.sensor_title'),
            size: "large",
            column: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_descriptions_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_5, _toDisplayString(_ctx.$t('device_details.overview.sensor_model_label')), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.station?.metadata['elichens/protected/sensor/model'] || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_n_descriptions_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.$t('device_details.overview.sensor_firmware_label')), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.station?.metadata['elichens/protected/sensor/firmware'] || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ])
      ]),
      _createElementVNode("div", _hoisted_7, [
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_n_descriptions, {
            hoverable: "",
            "label-placement": "left",
            title: _ctx.$t('device_details.overview.firmware_title'),
            size: "large",
            column: 1
          }, {
            default: _withCtx(() => [
              _createVNode(_component_n_descriptions_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.$t('device_details.overview.hardware_label')), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.station?.metadata['elichens/protected/firmware/hardware'] || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_n_descriptions_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('device_details.overview.version_label')), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.station?.metadata['elichens/protected/firmware/version'] || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              }),
              _createVNode(_component_n_descriptions_item, null, {
                label: _withCtx(() => [
                  _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.$t('device_details.network.carrier_label')), 1 /* TEXT */)
                ]),
                default: _withCtx(() => [
                  _createTextVNode(" " + _toDisplayString(_ctx.station?.network?.carrier || '-'), 1 /* TEXT */)
                ]),
                _: 1 /* STABLE */
              })
            ]),
            _: 1 /* STABLE */
          }, 8 /* PROPS */, ["title"])
        ])
      ])
    ])
  ]))
}